// extracted by mini-css-extract-plugin
export var finish = "-2Bm+";
export var finishes = "NXQ4N";
export var label = "_7NsKu";
export var main = "d6MH2";
export var preview = "kDz-p";
export var sample = "ixBBc";